import { UserProps } from "modules/auth/users/store/actionType";
import { SyntheticEvent, useEffect, useState } from "react";
import { connect } from "react-redux";
import { updateUserRoles } from "../../store/action";
import MultiSelectForm from "components/form/MultiSelectionForm";
import {Error, SubmitButton} from "components";
import { fetchAllRoles } from "modules/auth/role/store/action";

interface OwnProps {
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
  userData: UserProps;
}

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps & OwnProps;
const HandleUpdateUserRole: React.FC<Props> = ({
  closeModal,
  userData,
  onUpdateUserRole,
  fetchAllRoles,
  onFetchRoles,
}) => {
  const [formData, setFormData] = useState<{ role_ids: string[] }>({
    role_ids: userData.roles.map((items) => items.id) || [],
  });
  const [error, setError] = useState<{ role_ids?: string[] }>({
    });
    const [loading, setLoading] = useState<boolean>(false);
  useEffect(() => {
      onFetchRoles();
    }, [onFetchRoles]);
  const roles = fetchAllRoles?.roles || [];
   const handleChange = (
      e: React.ChangeEvent<
        HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
      >
    ) => {
      const { name, value } = e.target;
      setFormData({
        ...formData,
        [name]: value,
      });
      setError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
    };
  
  const handleSave = async (e: SyntheticEvent<HTMLButtonElement>) => {
      e.preventDefault();
      setLoading(true);
    if (formData.role_ids.length === 0) {
      setError((prevErrors) => ({
        ...prevErrors,
        title: "Please select at least one role",
      }));
    }
    if (formData.role_ids.length > 0) {
      await onUpdateUserRole(userData.id, formData.role_ids);
      setLoading(false);
      closeModal(false);
    }
  };
  
  return (
    <>
      <form>
         <h2 className="text-2xl font-bold text-center mb-4">Update User Role</h2>
        <div>
          <MultiSelectForm
            label="Roles"
            id="roles"
            name="roles"
            expandParent
            value={formData.role_ids}
            option={roles}
            onChange={(selected) =>
              handleChange({
                target: { name: "role_ids", value: selected },
              } as any)
            }
          />
          {error.role_ids && <Error>{error.role_ids}</Error>}
        </div>
        <div className="flex items-center justify-between mt-6">
          <SubmitButton loading={loading} onClick={handleSave} />
        </div>
      </form>
    </>
  );
};
const mapStateToProps = (state: any) => {
  return {
    fetchAllRoles: state.roles?.fetchRolesState,
  };
};
const mapDispatchToProps = (dispatch: any) => ({
  onFetchRoles: () => dispatch(fetchAllRoles()),
  onUpdateUserRole: (user_id: string, role_ids: string[]) =>
    dispatch(updateUserRoles(user_id, role_ids)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HandleUpdateUserRole);
